import {environment} from '../../environments/environment';

export class Settings {

    static get API_ENDPOINT() {
        return environment.apiEndpoint + 'api/';
    }

    static IS_APP = environment.isApp;

    static versionUpdateAvailable = false;

    static isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;

    static isMobileDevice = Settings.isIpad || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

}
